import React, { useState } from 'react'
import Popup from '../../App/Common/Popup/Popup'
import parse from 'html-react-parser';
import { Link } from "react-router-dom";

function Comment({result, header, resultFilenames, currentFilenames, resultFileLinks, currentFileLinks, handlePopUp, title}) {
    const getDisplayFilename = (filename, maxLength = 15) => {
        console.log(filename)
        const ext = filename.split('.').pop();
        const name = filename.slice(0, filename.lastIndexOf('.'));
        
        if (name.length <= maxLength) {
            return filename;
        }
    
        return `${name.slice(0, maxLength)}... .${ext}`;
    }
    console.log(result, header)
    return (
    <Popup onClose={handlePopUp} noButton>
  {/* Заголовок задания */}
  <div>
    {title}: 
    <span className='question__header_title' style={{marginLeft: '10px'}}>{header.title}</span>
  </div>

  {/* Задание */}
  <div className="comment__headerTask">Задание: {parse(result.text)}</div>

  <div className="fileResult__commentResult">
    {/* Баллы за задание */}
    {/* {result.is_correct !== undefined && (
      <div className="fileResult__commentPoint">
        Баллы <span>{result.is_correct}</span>
      </div>
    )} */}

    {/* Комментарий к ответу */}
    <div className="fileResult__commentBlock_wrap">
      <div>Комментарий к заданию</div>
      {result?.comment ? (
        <div className="fileResult__commentBlock" style={{ display: "flex", gap: "5px" }}>
          {parse(result?.comment)}
        </div>
      ) : (
        <div className="fileResult__commentBlock"></div>
      )}
    </div>
  </div>
</Popup>
  )
}

export default Comment